import { useMutation } from '@tanstack/react-query'

import { APIInstance } from '@/utils/functions/instance'
import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'

import { TUpdateInfoParamsType } from './type'

export function useUpdateInfo({
  disableToast,
  ...rest
}: IApiBaseTypes<TUpdateInfoParamsType> = {}) {
  return useMutation({
    mutationFn: async (payload: TUpdateInfoParamsType) =>
      await APIInstance<IResponseType<{}>>({
        url: 'mrf/personal-info/',
        method: 'patch',
        data: payload
      }),
    retry: 0,
    mutationKey: ['updatePersonalInfo'],
    ...rest
  })
}
